import { useState } from "react";
import FilledButton from "../../../component/filled-button/FilledButton";
import Popup from "../../../component/popup/Popup";
import { TableHeader, TableRow } from "../../../component/table/Table";
import {
  fundbenchmarkTableData,
  fundbenchmarkTableHead,
} from "../../../data/data";
import NewBenchmark from "./add-new-benchmark-modal/NewBenchmark";
import styles from "./fundbenchmark.module.scss";
import UpdateBenchmarkModal from "./update-benchmark-modal/UpdateBenchmarkModal";
const FundBenchmark = () => {
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const handleOpen = () => {
    setModal(!modal);
  };
  const handleModal = () => {
    setModal(!modal);
  };
  const handleOpen1 = () => {
    setUpdateModal(!updateModal);
  };
  const handleModal1 = () => {
    setUpdateModal(!updateModal);
  };
  const buttonGroup = (
    <div className={styles.buttonGroup}>
      <FilledButton
        title="Add"
        customClass={styles.addButton}
        handleClick={() => {}}
      />
      <FilledButton
        title="Remove"
        customClass={styles.removeButton}
        handleClick={() => {}}
      />
    </div>
  );

  return (
    <>
      {modal && (
        <Popup Children={NewBenchmark} handleClose={() => handleModal()} />
      )}
      {updateModal && (
        <Popup
          Children={UpdateBenchmarkModal}
          handleClose={() => handleModal1()}
        />
      )}
      <div className={styles.mainContainer}>
        <div className={styles.benchmarkButton}>
          <FilledButton
            title="Add New Benchmark"
            customClass={styles.addNewBenchmarkButton}
            handleClick={() => handleOpen()}
          />
          <FilledButton
            title="Update Benchmarks"
            customClass={styles.updateBenchmarkButton}
            handleClick={() => handleOpen1()}
          />
        </div>
        <div className={styles.tableContent}>
          <table className={styles.table} cellSpacing={0}>
            <thead>
              <TableHeader
                data={fundbenchmarkTableHead}
                customClass={styles.tableHead}
              />
            </thead>
            <tbody>
              {fundbenchmarkTableData.map((item, index) => {
                return (
                  <TableRow
                    customClass={styles.tableBodyRow}
                    buttonGroup={buttonGroup}
                    fundbenchmarkData={item}
                    key={index}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default FundBenchmark;
